module.exports = __webpack_public_path__ + "img/chinese-temple.fc2dba01.svg";